import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api/contact`;

const getAuthHeader = () => {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const contactAPI = {
  // Get all submissions
  getSubmissions: async (params = {}) => {
    const response = await axios.get(`${API_BASE}/submissions`, {
      params,
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Get single submission
  getSubmissionById: async (id) => {
    const response = await axios.get(`${API_BASE}/submissions/${id}`, {
      headers: getAuthHeader()
    });
    return response.data;
  },

  // Update submission status
  updateStatus: async (id, status) => {
    const response = await axios.patch(
      `${API_BASE}/submissions/${id}/status?status=${status}`,
      {},
      { headers: getAuthHeader() }
    );
    return response.data;
  }
};
